export default "__VITE_ASSET__kN3Zbr53__"